var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Editable',{ref:"rename",attrs:{"value":_vm.view.name},on:{"change":function($event){return _vm.renameView(_vm.view, $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }